import ExtraFiltersCollapse from './ExtraFiltersCollapse.jsx';

export default ExtraFiltersCollapse;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/ExtraFiltersCollapse/index.js